<template>
    <div :class="menuOpen ? 'bg-white vh-100 vw-100' : 'bg-black vh-100 vw-100'" class="d-flex flex-column">
      <header class="text-center py-3">
        <button class="btn p-0 border-0 position-relative" @click="toggleMenu" style="width: 28px; height: 28px;">
          <template v-if="!menuOpen">
            <div class="hamburger-line" style="top: 6px;"></div>
            <div class="hamburger-line" style="top: 18px;"></div>
          </template>
          <template v-else>
            <div class="cross-line" style="transform: rotate(45deg);"></div>
            <div class="cross-line" style="transform: rotate(-45deg);"></div>
          </template>
        </button>
      </header>
      <div v-if="!menuOpen" class="d-flex justify-content-center align-items-center flex-column h-75 text-center">
        <h1 class="display-3 text-secondary text-shadow">{{ headline }}</h1>
        <h2 class="text-secondary mt-3" style="font-size: 100%">{{ subHeadline }}</h2>
      </div>
      <LogInMenu
        v-else
        :headline="headline"
        :subHeadline="subHeadline"
        :subHeadlineFontSize="subHeadlineFontSize"
        :adminMode="adminMode"
        @close="toggleMenu"
      />
      <footer :class="menuOpen ? 'footer-black-text' : 'footer-white-text'" class="mt-auto text-center py-3 position-absolute bottom-0 w-100">
        <div>
          <strong>The Lomax Law Firm</strong>
        </div>
        <div>Join: <span>attorneys@thelomaxlawfirm.com</span></div>
        <div>Questions: <span>attyconnect@thelomaxlawfirm.com</span></div>
        <div class="mt-2">
          <button class="btn btn-link admin-signin" @click="adminSignIn">Admin Signin</button>
        </div>
      </footer>
    </div>
  </template>
  
  <script>
  import { ref } from 'vue';
  import LogInMenu from '@/components/LogInMenu.vue';
  
  export default {
    name: 'LLFC-Home',
    components: {
      LogInMenu
    },
    setup() {

      const headline = ref('Lomax Law Firm Connect');
      const subHeadline = ref('admin portal');
      const menuOpen = ref(window.location.hostname === 'admin.lomaxlawconnect.com');
      const subHeadlineFontSize = 18; // Subheadline font size in px
      const adminMode = ref(true);
  
      const toggleMenu = () => {
        headline.value = 'Lomax Law Firm Connect';
        subHeadline.value = 'admin portal';
        adminMode.value = true;
        menuOpen.value = !menuOpen.value;
      };
  
      const adminSignIn = () => {
        if (!menuOpen.value) {
          headline.value = 'Lomax Law Firm Connect';
          subHeadline.value = 'admin portal';
          adminMode.value = true;
          menuOpen.value = true;
        }
      };
  
      return {
        headline,
        subHeadline,
        menuOpen,
        toggleMenu,
        subHeadlineFontSize,
        adminSignIn,
        adminMode
      };
    }
  };
  </script>